








































































































































import Datetime from '@/components/FlatPickr/DateTime.vue';
import { DiscountParams } from '@/store/interfaces/discount';
import { currencyKeyboardEventValidation } from '@/util/CurrencyValidation';
import { tCashbackParams } from '@/store/interfaces/cashback';
import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'BasicInfo',
  components: {
    Datetime,
  },
  props: {
    model: {
      type: Object as PropType<DiscountParams | tCashbackParams>,
    },
  },
  data: () => ({
    clean: true,
    currencyKeyboardEventValidation: currencyKeyboardEventValidation,
    campaignbonus: [
      {
        name: 'Porcentaje',
        id: 'percentage',
      },
      {
        name: 'Monto',
        id: 'fixed',
      }
    ],

    campaignKinds: [
      {
        name: 'Individual',
        id: 'individual',
      },
      {
        name: 'Colectivo',
        id: 'collective',
      }
    ],

    networks: [
      {
        name: 'Todas',
        id: 'all',
      },
      {
        name: 'Mastercard',
        id: 'mastercard',
      },
      {
        name: 'Visa',
        id: 'visa',
      }
    ],
  }),
  computed: {
    syncedModel: {
      get(): DiscountParams | tCashbackParams {
        return this.model;
      },
      set(value: DiscountParams | tCashbackParams): void {
        this.$emit('update:model', value);
      },
    },
  },
  watch: {
    'syncedModel.kind': {
      handler(kind: 'collective' | 'individual'): void {
        if (kind === 'collective') {
          this.syncedModel.bonus = 'percentage';
        }
      },
    },
  },
});
